import React from 'react';

interface Props
{
  type?: string,
}
const Message: React.FC<Props> = ({type, children}) => <div className={['message', type].join(' ')}>{children}</div>;

export default Message;